import script from "./GartenKultur-Website.vue?vue&type=script&setup=true&lang=js"
export * from "./GartenKultur-Website.vue?vue&type=script&setup=true&lang=js"

import "./GartenKultur-Website.vue?vue&type=style&index=0&id=4faba6a3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4faba6a3"]])

export default __exports__